<template>
  <section
    ref="container"
    class="page-container">
    <div
      class="main-header ">
      <div class="flex-sb">
        <div class="">

          <div class="header-title flex">
            <template>
              <span
                class="icon icon-content"
              >
                <font-awesome-icon  icon="people-group"/>
              </span>
            </template>
            <h3>{{ detailData.team_nm }}</h3>
          </div>
          <div class="mg-b-8">

            <span class="header-date">Created  <span class="number-color number-fontsize">{{ detailData.created_date }}</span></span>
            <span class="header-date">Last Updated  <span class="number-color number-fontsize">{{ detailData.updated_date }}</span></span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!edit"
      class="main-container">
      <div
        class="main-col">
        <div class="middle-col">
          <div class="detail ">
            <div class="detail_title flex-sb-center">
              <span>Details</span>
            </div>
            <div
              class="table">
              <div class="th flex-sb-center">
                <span>
                  <span class="mg-r-10">
                    Published Youtube
                  </span>
                </span>
                <span
                  class="blue hand"
                  @click="handleEdit">Edit</span>
              </div>
              <div class="tr">
                <span>
                  <span>{{fileName}}</span>
                  <p class="color-gray2">{{file_size}}</p>
                </span>
                <span>
                  <v-button
                    v-if="video_file.url"
                    icon="download"
                    gray
                    @click="openFile(video_file)">Download</v-button>
                </span>
              </div>
              <div class="tr">
                <span>
                  Video Thumbnail (Optional)
                </span>
                <span  >
                  <span
                    v-if="preview_file.url"
                    class="blue pointer"
                    @click="openFile(preview_file)">
                    {{preview_file.client_name}}
                  </span>
                </span>
              </div>
              <div class="tr">
                <span>Team</span>
                <span>{{detailData.team_nm}}</span>
              </div>
              <div class="tr">
                <span>Member</span>
                <span>{{detailData.member}}</span>
              </div>
              <div class="tr">
                <span>Publish on HoldCover</span>
                <span>{{detailData.status_language}}</span>
              </div>
            </div>
            <div class="detail_title flex-sb-center">
              <span>Election Results</span>
              <v-button
                green
                @click="handleUpdateStatus" >Add/Subtract</v-button>
            </div>
            <div class="election-results-table">
              <div class="">
                <span class="flex flex-align-center mg-b-8">
                  <span class="mg-r-15 fs-14 fw-600">Voted#: {{detailData.total_vote_num||0}}</span>
                  <span class="mg-l-15  fs-14 fw-600">Calc#: {{detailData.calc_num||0}}</span>
                </span>
                <template v-if="tableData.length<=0">
                  <span class="fs-14 fw-400 color-dark">No record</span>
                </template>
                <template v-else>
                  <span
                    v-for="(item,index) in tableData"
                    :key="index"
                    class="tr">
                    <span class="color-gray2 fs-14 fw-400 ">{{item.created_date}}</span>
                    <span
                      v-if="item.cs_id!=0"
                      class="color-gray2 fs-14 fw-400 "
                      :class="[item.vote_num>0?'color-green':'color-red']">{{item.vote_num>0?`+${item.vote_num}`:`${item.vote_num}`}}</span>
                    <span
                      v-else
                      class="color-gray2 fs-14 fw-400 blue">{{item.email?item.email:item.mobile_no}}</span>
                  </span>
                </template>
              </div>
            </div>
            <v-pagination
              :total="pageConfig.total"
              :current="pageConfig.currentPage"
              @currentChange="currentChange" />
          </div>
        </div>
        <div class="right-col">
          <div class="">
            <div
              class="btn-list "
            >
              <span
                class="title">Support</span>
              <div
                class="button-width mg-t-8">
                <span  class="mg-t-15 block">
                  <v-button
                    gray
                    class="mg-t-15"
                    @click="handleBack"
                  >
                    <span>Back</span>
                  </v-button>
                </span>
              </div>
            </div>
          </div>
          <div class="box box-remark">
            <span class="title">Remarks</span>
            <div class="remarks-container">
              <div
                v-for="(item, index) in remarkList"
                :key="index"
                class="remark-box">
                <div class="remark-header">
                  <span>{{ item.cs_name }}</span>
                  <span>{{ item.created_at }}</span>
                </div>
                <p>{{ item.message }}</p>
              </div>
            </div>
            <div class="remark-add">
              <v-input
                v-model="message"
                class="mg-b-15"
                append="Add"
                @handlerAppend="handlerSendRemark"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <team-form
      v-else
      :id="id"
      :from="detailData"
      :remark="remarkList"
      is-edit
      @success="handleRefresh"
      @cancel="handleCancel"></team-form>
    <add-subtract-dialog
      v-model="isShow"
      :max-vote="detailData.total_vote_num"
      @refresh="handleRefresh"></add-subtract-dialog>
  </section>
</template>

<script>

import {getPopTravellerDetail, addPopTravellerRemark} from '@/api/pop-traveller-team'
import MixinOptions from '@/mixins/options'
import TeamForm from '@/views/records/micropolicy/components/tourist/team-form'
import AddSubtractDialog from './component/add-subtract-dialog'
export default {
  name: 'touristDetail',
  components:{
    AddSubtractDialog,
    TeamForm,
  },
  mixins: [MixinOptions],
  data () {
    return {
      detailData: {},
      isShow:false,
      message: '',
      remarkList: [],
      edit:false,
      pageConfig:{
        total: 0,
        currentPage: 1
      },
    }
  },
  computed:{
    id(){
      return this.$route.params.id
    },
    video_file(){
      let {video_file} = this.detailData||{}
      return video_file||{}
    },
    preview_file(){
      let {preview_file} = this.detailData||{}
      return preview_file||{}
    },
    tableData(){
      let {record} = this.detailData||{}
      let {data} = record||{}
      return data||[]
    },
    fileName(){
      let {client_name=''} = this.video_file
      let extName = client_name.split('.').pop()
      return extName.toString().toUpperCase()
    },
    file_size(){
      let {file_size} = this.video_file
      if(file_size === 0) return '0 Bytes'
      const k = 1000
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(file_size) / Math.log(k))
      return parseFloat((file_size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  },
  watch:{
    id:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getPopTravellerDetail()
        }
      }
    },
  },
  methods: {
    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getPopTravellerDetail()
    },
    travelFlightData(index){
      return this.nm_traveler_list.length>0?this.nm_traveler_list[index]||{}:{}
    },
    openFile({url}) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    handleBack(){
      this.$router.back()
    },
    handleCancel(){
      this.edit = false
    },
    handleUpdateStatus(){
      this.isShow = true
    },
    handleEdit(data,flightData,num){
      this.flightData = {...data,...flightData,num}
      this.edit = true
    },
    handleRefresh(){
      this.edit = false
      this.pageConfig.currentPage = 1
      this.network().getPopTravellerDetail()
    },
    handlerSendRemark(){
      if(this.message){
        this.network().addRemark()
      }
    },
    network(){
      return{
        getPopTravellerDetail: async () => {
          const {data} = await getPopTravellerDetail({
            team_id: this.id,
            page: this.pageConfig.currentPage,
          })
          this.detailData = data
          let {record} = data
          this.pageConfig.total = record.total
          this.remarkList = data.remark_list
        },
        addRemark: async () => {
          const {data} = await addPopTravellerRemark({
            team_id: this.id,
            message: this.message
          })
          this.message = ''
          this.remarkList.unshift(data)
        },

      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  min-height: 100%;
  padding-bottom: 40px;
  box-sizing: content-box;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }


  .yellow{
    background-color: #DBAB09;
  }
  .red{
    border: 1px solid #CB2431;
    background: #fff;
    color: #D73A49!important;
  }
  .black{
    border: 1px solid #6A737D;
    background: #fff;
    color: #24292E!important;
  }
  .purple{
    background-color: #6F42C1;
  }
  .green{
    background: #28A745;
    color: white!important;
  }
  .orange {
    background: #E36209;
  }
  .void{
    background: #d73a49;
  }
  .main-container {
    padding: 0 88px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .detail_title{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      color: #24292E;
      margin-bottom: 20px;
    }
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }
    .buy-quote-container{
      flex: 1;
    }
    .middle-col {
      flex: 1;
      min-width: 600px;

      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .renew_list{
        margin-bottom: 20px;
        p{
          align-items: center;
          cursor: pointer;
          margin-bottom: 10px;
          .icon{
            width: 22px;
            height: 22px;
            background: #E1E4E8;
            border-radius: 5px;
          }
          .money{
            color: #0366D6;
            font-weight: 400;
            font-size: 16px;
          }
          .amount_tag{
            padding: 3px 12px;
            border-radius: 100px;
            font-weight: 600;
            font-size: 12px;
            font-family: 'Inter';
            font-style: normal;
            margin-left: 15px;
            background: #FFFFFF;
            white-space: nowrap;
          }
          .tag_auto{
            border: 1px solid #0366D6;
            color: #0366D6;
          }
          .tag_terms{
            border: 1px solid #E1E4E8;
            color: #586069;
          }
          .active{
            font-weight: 600;
            font-size: 20px;
            color: #24292E;
          }
        }
        .cursor_default{
          cursor: default;
        }
        .btn{
          .el-button{
            flex: 1;
          }
        }
      }
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        .status{
          color: #68C23A
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        .percent{
          padding: 0px 6px;
          background: rgba(27, 31, 35, 0.08);
          border-radius: 100px;
          height: 16px;
          font-weight: 600;
          font-size: 12px;
          color: #586069;
          margin-left: 4px;
        }
      }
      .success{
        color: rgba(255, 255, 255, 1);
        background: rgba(46, 164, 79, 1);
      }
      .tr{
        display: flex;
        .mg-r-8{
          margin-right: 8px !important;
        }
      }
      .blue{
        color: #0366D6!important;
      }
      .bank-pay{
        margin-bottom: 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266!important;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-radius: 15px;
        border: 1px solid rgba(176, 136, 0, 0.2);

        .title {
          margin-top: 10px;
          margin-bottom: 5px;
        }
      }


      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .mt-10{
    margin-top: 10px;
    display: inline-block;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 88px 0px 88px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
  .pdb-10{
    padding-bottom: 10px;
  }

  .table {
    //border: 1px solid #E1E4E8;
    &.table_no_title{
      .tr:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border: 1px solid #E1E4E8;
      }
    }
    .table_tr_border0{
      .tr:last-child{
        border-radius: 0!important;
      }
    }
    .th{
      padding: 16px;
      background: $gray;
      border: 1px solid #E1E4E8;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: $dark!important;
      font-weight: 600;
      font-size: 14px;
      .gray-color{
        color: #677FA1;
      }
    }
    .tr {
      padding: 8px 16px;
      border: 1px solid #E1E4E8;
      border-top: 0;
      background: #fff!important;
      display: flex;
      align-items: center;

      /* Text/text-gray */
      &.dis-block{
        display: block;
      }
      color: #586069;
      &.tr-gray__title{
        background: $gray!important;
        span{
          color: #24292E!important;
        }
        .key-alt-down{
          color: #0366D6!important;
          cursor: pointer!important;
        }
      }
      span{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #586069;
        &:nth-child(2){
          color: #24292E!important;
          &.blue{
            color: #0366D6!important;
          }
          &.key-alt-down{
            color: #0366D6!important;
            cursor: pointer!important;
          }
        }
        .btn-green{
          span{
            color: #fff!important;
          }
        }
      }
      .blue{
        color: #0366D6!important;
      }
      .fw-600{
        font-weight: 600;
      }
      .top-algin{
        align-self: baseline;
      }
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
      &:nth-child(2n){
        background: #fff;
      }
      &:last-child{
        //border: 0;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      .span-status{
        &.blue {
          background: #0366D6!important;
          color: #fff!important;
        }
      }
    }
  }
}
.span-status{
  color: #fff!important;
  padding: 1px 8px;
  border-radius: 100px;
  margin-right: 15px;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  &.blue {
    background: #0366D6!important;
    color: #fff!important;
  }
}
.mg-b-20{
  margin-bottom: 20px;
}
.status-height{
  height: 23px;
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    min-height: 18px !important;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
}
/deep/.file-box__detail{
  .flex-sb{
    justify-content: flex-start;
  }
  .flex-column{
    width: 50%;
  }

}
.color-red{
  color: #CB2431!important;
}
.election-results-table{
  border: 1px solid #D1D5DA;
  border-radius: 6px;
  width: 100%;
  padding: 16px;
  .tr{
    width: 100%;
    margin-bottom: 8px;
    display: flex;
    span{
      width: 50%;
      &.blue{
        color:$blue!important;
      }
    }
  }
  .color-red{
    color: #CB2431;
  }
}

</style>
